









































































































































/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator';
import LayoutContent from '@/components/LayoutContent.vue';
import TagInput from '@/components/TagInput.vue';
// import FormInput from '@/components/FormInput.vue';
import FileInput from '@/components/FileInput.vue';
import Loader from '@/components/Loader.vue';
import Header from '@/components/Table/Header.vue';
import api, { apiProduction, apiSandbox } from '@/libs/api';
import { MerchantsAdds } from '@/libs/api.interfaces';
// eslint-disable-next-line import/no-cycle
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
// import ToggleSelect from '@/components/ToggleSelect.vue';
import Button from '@/components/Button.vue';
import ColorPicker from '@/components/ColorPicker.vue';

    @Component({
      components: {
        LayoutContent,
        Loader,
        TagInput,
        Header,
        // ToggleSelect,
        Button,
        ColorPicker,
        FileInput,
      },
    })
export default class ThemeDetail extends Vue {
    loading = false;
    loadingSubmit = false;

    merchantLogoName = '';
    merchantLogo = '';
    backgroundColor = '#0b8cd5'; // default white
    textColor = '#000000';
    buttonColor = '#0b8cd5';
    buttonTextColor = '#FFFFFF';
    addsMerchant!: MerchantsAdds;
    baseUrl = process.env.VUE_APP_API_URL

    handleFileName(val: [string, string]) {
      this.loading = false;
      if (val[0] === 'merchantLogo') {
        this.merchantLogoName = val[1].toString();
      }
    }

    // showImage(val: string, name: string) {
    //   if (val) {
    //     this.showModal = true;
    //     this.modalImage = val;
    //     this.modalFileName = name;
    //   } else {
    //   // this.$refs.fileInput.click();
    //   }
    // }

    async created() {
      await this.getAddsMerchant();
    }

    // eslint-disable-next-line class-methods-use-this
    async backgroundColorSelected(color: string) {
      this.backgroundColor = color;
      console.log('background color selected:', color);
    }

    // eslint-disable-next-line class-methods-use-this
    async textColorSelected(color: string) {
      this.textColor = color;
      console.log('text color selected:', color);
    }

    // eslint-disable-next-line class-methods-use-this
    async buttonColorSelected(color: string) {
      this.buttonColor = color;
      console.log('button color selected:', color);
    }

    // eslint-disable-next-line class-methods-use-this
    async buttonTextColorSelected(color: string) {
      this.buttonTextColor = color;
      console.log('button text color selected:', color);
    }

    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-empty-function
    async getAddsMerchant() {
      const id = this.$route.params.type;
      try {
        this.loading = true;
        const { data } = await api.get(`/res/adds-reseller-main/${id}`);
        this.addsMerchant = data;
        this.merchantLogoName = data.merchant_logo || '';
        this.backgroundColor = data.background_color || '#0b8cd5';
        this.textColor = data.text_color || '#000000';
        this.buttonColor = data.button_color || '#0b8cd5';
        this.buttonTextColor = data.button_text_color || '#FFFFFF';
        this.loading = false;
      } catch (err) {
        this.loading = false;
        // showToast(
        //   ToastType.FAILED,
        //   'Error',
        //   'Failed to get additional detail',
        // );
      }
    }

    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-empty-function
    async submitAddsMerchant() {
      const id = this.$route.params.type;
      this.loading = false;
      this.loadingSubmit = true;
      try {
        if (this.addsMerchant) {
          const { data } = await api.put(`/res/adds-reseller-main/theme/${id}`, {
            merchant_logo: this.merchantLogoName,
            background_color: this.backgroundColor,
            text_color: this.textColor,
            button_color: this.buttonColor,
            button_text_color: this.buttonTextColor,
          });
          showToast(ToastType.SUCCESS, data.case, data.message);
        } else {
          const { data } = await api.post(`/res/adds-reseller-main/theme/${id}`, {
            merchant_logo: this.merchantLogoName,
            background_color: this.backgroundColor,
            text_color: this.textColor,
            button_color: this.buttonColor,
            button_text_color: this.buttonTextColor,
          });
          showToast(ToastType.SUCCESS, data.case, data.message);
        }
      } catch (err) {
        showToast(ToastType.FAILED, 'Oops… Sorry', (err as any).response.data.error.errors.map((e: any) => e.message));
        this.loading = false;
      }
      this.loadingSubmit = false;
      this.getAddsMerchant();
    }
}
